// Skladba zateplení – propojení seznamu vrstev s řezem
(() => {
    const cut = document.querySelector(".JS-layers-cut");
    const layerItems = document.querySelectorAll(".JS-layer-item");

    function setLayer(id) {
        layerItems.forEach((item) => {
            const active = item.dataset.layer === id;
            item.classList.toggle("active", active);
            item.querySelector("button").setAttribute("aria-expanded", active ? "true" : "false");
        });

        if (!cut) return;
        cut.classList.toggle("has-active", id !== null);
        cut.classList.toggle("anchors-active", id === "4");
        cut.querySelectorAll(".cut-layer").forEach((layer) => {
            layer.classList.toggle("active", layer.dataset.layer === id);
        });
    }

    layerItems.forEach((item) => {
        item.querySelector("button").addEventListener("click", () => {
            setLayer(item.classList.contains("active") ? null : item.dataset.layer);
        });
    });

    if (cut) {
        cut.querySelectorAll(".cut-layer").forEach((layer) => {
            layer.addEventListener("click", () => setLayer(layer.dataset.layer));
        });
    }

    if (layerItems.length) {
        setLayer(layerItems[0].dataset.layer);
    }
})();
